<template>
  <div>
    <template v-for="(item, index) in config">
      <div :key="item.key + index">
        <el-card style="margin-bottom: 10px">
          <div slot="header">
            <span>{{ item.name }}</span>
          </div>
          <component
            :ref="item.key"
            v-if="item.type === 2"
            :is="getComponents(item.key)"
            :tableData.sync="tableData[index].data"
            :operate="operate"
          >
          </component>
        </el-card>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: ["config", "data", "operate"],
  computed: {
    getComponents() {
      return function (val) {
        return val;
      };
    },
    tableData: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  data() {
    return {
      // tableData: [],
    };
  },
  methods: {
    verify() {
      let arr = [];
      this.config.forEach((item) => {
        arr.push(this.$refs[item.key][0].verify());
      });
      return arr;
    },
  },
};
</script>
